import React, { useCallback, memo, type MouseEvent } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { ThemedButton } from '@atlassian/jira-business-theme-components';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { useTimelineScroller } from '@atlassian/jira-software-roadmap-utils/src/utils/timeline-scroller';
import {
	TODAY_BUTTON_CLICKED,
	useInteractionMetrics,
} from '../../../../common/utils/interaction-metrics';
import { useTimelineUI } from '../../../../controllers/timeline-ui';
import messages from './messages';

const TodayButton = () => {
	const { formatMessage } = useIntl();

	const interactionMetrics = useInteractionMetrics();

	const { scrollTo } = useTimelineScroller();
	const [{ todayPosition }] = useTimelineUI();

	const fireInteractionMetrics = useCallback(() => {
		interactionMetrics[TODAY_BUTTON_CLICKED].start();
		// waiting for the browser to re-render timeline with updated scroll position
		requestAnimationFrame(() => {
			interactionMetrics[TODAY_BUTTON_CLICKED].stop({
				stopTime: Math.floor(performance.now()),
			});
		});
	}, [interactionMetrics]);

	const onClick = useCallback(
		(event: MouseEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => {
			fireUIAnalytics(analyticsEvent, 'todayButton');
			scrollTo({ left: todayPosition });
		},
		[scrollTo, todayPosition],
	);

	return (
		<ThemedButton onClick={onClick} onMouseDown={fireInteractionMetrics}>
			{formatMessage(messages.today)}
		</ThemedButton>
	);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default memo<Record<any, any>>(TodayButton);
